module.exports = __webpack_public_path__ + "static/media/symptomsicon_lower_back_pain_uni.d629474e.svg";